Preloader = require "lib/preload"
SlideView = require "views/slide"
{ Sound } = Application.actions()

class ImageCollectionView extends SlideView
  template: require("./template")
  fitTextOnResize: false
  fitTextOnRender: false

  events: ->
    "iostap .btn-done":        "submit"
    "iostap .image-details":   "hideDetails"
    "iostap .tappy":           "toggleThumbnail"

  serialize: ->
    data = super
    data.tappies = _.filter(data.images or [], (d) -> d.image)
    data.hasPrompt = true
    data

  onResize: ->
    @el.classList.remove("active")

    images = _.pluck(@options.data.images, "image")

    Preloader.load _.compact(images), =>
      @setTappyHeight()
      @fitText =>
        window.setTimeout (=> @el.classList.add("active")), 300

  onDetailResize: -> 
    image = @getEl("active-details")
    @limitImageSize(image)

  show: ->
    @setEl @findOne(".tappies-parent"), "parent"
    @setEl @findOne(".tappies"), "tappies"
    @setEl @findOne(".title-wrapper"), "title"
    @setEl @findAll(".image-details"), "imageDetails"

    @listenTo this, "resize", @onResize
    @onResize()
    @toVisit = [0...@serialize().tappies.length]
    @hideDetails()

  beforeHide: ->
    Sound.fadeOut(@currentSrc, 500, 0.02) if @currentSrc

  setTappyHeight: ->
    length = @getEl("tappies").children.length
    length = Math.ceil(length / 2) if length >= 4

    outerHeight = @getEl("parent").offsetHeight - @getEl("title").offsetHeight
    tappyHeight = outerHeight / length
    tappyHeight = Math.min(tappyHeight, 220)

    for el, i in @getEl("tappies").children
      el.style.height = "#{tappyHeight}px"

  limitImageSize: (imgDetails) ->
    img = imgDetails.querySelector(".image-full-size")
    txt = imgDetails.querySelector(".caption")
    ch  = imgDetails.offsetHeight - txt.offsetHeight
    cw  = imgDetails.offsetWidth

    scale = _.max [ img.height / ch, img.width / cw ]

    img.style.height = "#{img.height / scale}px"

  toggleThumbnail: (e) ->
    @showDetails e.currentTarget, true

  showDetails: (tappy, animate) ->
    index      = +tappy.dataset.index
    imgDetails = @getEl("imageDetails").item(index)
    narration  = @serialize().tappies[index].narration
    loaded     = false

    Sound.stop(@currentSrc) if @currentSrc
    if (@currentSrc = narration) and not @withoutNarration
      @showLoadingNarration()
      Sound.play narration,
        cb: ->
        onProgress: =>
          unless loaded
            loaded = true
            @hideLoadingNarration()

    @toVisit   = _.without @toVisit, index

    @setEl imgDetails, "active-details"

    @setState("touched") if _.isEmpty(@toVisit)
    @setState("active", "details")
    @showLightbox()

    @listenTo this, "resize", @onDetailResize
    @onDetailResize()

    tappy.classList.add("visited")

    @transform imgDetails,
      opacity: 1
      transition: if animate then "all 300ms" else ""
    
    imgDetails.classList.add("image-details-visible")

  hideDetails: ->
    Sound.fadeOut(@currentSrc, 500, 0.02) if @currentSrc

    return unless imgDetails = @getEl("active-details")

    @transform imgDetails,
      opacity: 0
      scale: 0.9
      transition: "all 300ms"
    
    imgDetails.classList.remove("image-details-visible")

    @trigger("ui", lightbox: false)
    @setState("inactive", "details")

  showLightbox: ->
    if @options.data.lightbox
      @trigger("ui", lightbox: @options.data.background or true)

  refresh: (params) ->
    if params.data.images.length is @options.data.images.length
      for { content }, i in params.data.images
        if content and @options.data.images[i]?.content isnt content
          changed = i

    super

    if changed? and tappy = @getEl("tappies").children[changed]
      @showDetails(tappy, false)


module.exports = ImageCollectionView
